module.exports = __webpack_public_path__ + "static/media/vulnerability-assessment.97cd96b9.png";